import { TableOption, TableSource } from '@tripointe/tripointe-cms/types';

import { TOOLTIPS_TEXTS } from './tooltips';

const homeScheduleTableTooltips = TOOLTIPS_TEXTS.homeScheduleTable;

export const BASE_HOME_SCHEDULE_OPTIONS: TableOption[] = [
  { action: 'mobileMenu', src: 'icons/more' }
];

export const BASE_HOME_SCHEDULE_TABLE_CONFIG: TableSource = {
  displayedColumns: [
    'date',
    'time',
    'name',
    'description',
    'phase',
    'attendees',
    'status',
    'options'
  ],
  displayedTitles: [
    'Date',
    'Time',
    'Name',
    'Description',
    'Phase',
    'Invitee(s)',
    'Status',
    'Actions'
  ],
  columnsConfig: [
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: true },
    { sorting: false },
    { sorting: true },
    { sorting: false }
  ],
  displayedTooltips: [
    homeScheduleTableTooltips.date,
    homeScheduleTableTooltips.time,
    homeScheduleTableTooltips.name,
    homeScheduleTableTooltips.description,
    homeScheduleTableTooltips.phases,
    homeScheduleTableTooltips.attendees,
    homeScheduleTableTooltips.status
  ],
  options: null,
  dataSource: []
};
